<template>
  <div class="auth-item">
    <Checkbox v-model="authed" @on-change="auth">
      <strong>{{ model.item }}</strong>
      <span style="font-size: .8em;" v-if="model.route">({{ model.route }})</span>
    </Checkbox>
  </div>
</template>

<script>
import { AuthItem } from '@/api/auth'

export default {
  name: 'item',
  data: function () {
    return {
      authed: this.model.role !== null
    }
  },
  props: ['model'],
  methods: {
    auth: function () {
      const role = this.$route.query.item
      AuthItem(role, this.model).then(async res => {
        this.$emit('refresh')
      })
    }
  }
}
</script>

<style>
.auth-item {
  padding: 10px;
}
</style>
